import React from "react";
import PropTypes from "prop-types";

import RegistrationStatusIcon from "components/RegistrationStatusIcon";

const RegistrationStatusItem = ({ registrationStatus, termName }) => {
  if (registrationStatus === null) {
    return null;
  }

  return (
    <div
      style={{padding: '5px 0'}}
      data-testid="registration-status-item"
    >
      <RegistrationStatusIcon severity={registrationStatus.severity} />
      <strong>{termName}: </strong>
      {registrationStatus.message}
    </div>
  );
};

RegistrationStatusItem.propTypes = {
  registrationStatus: PropTypes.object,
  termName: PropTypes.string,
};

export default RegistrationStatusItem;
